
import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQSection = () => {
  return (
    <div className="max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-4">Frequently Asked Questions</h2>
      <Accordion type="single" collapsible className="w-full">
        <AccordionItem value="item-1">
          <AccordionTrigger>How does the credit system work?</AccordionTrigger>
          <AccordionContent>
            Each credit represents a virtual value of 1 euro. You can earn credits by sharing your reagents with other labs, and then use these credits to request reagents from other institutions. This creates a circular economy of reagent sharing within the scientific community.
          </AccordionContent>
        </AccordionItem>
        
        <AccordionItem value="item-2">
          <AccordionTrigger>How do I ensure the quality of reagents I receive?</AccordionTrigger>
          <AccordionContent>
            All reagents listed on LabSwapp include detailed information about storage conditions, expiration dates, and usage history. You can communicate with the providing lab before confirming any swap to ask specific questions about quality and handling. Additionally, user ratings and reviews help maintain a trustworthy community.
          </AccordionContent>
        </AccordionItem>
        
        <AccordionItem value="item-3">
          <AccordionTrigger>Who pays for shipping costs?</AccordionTrigger>
          <AccordionContent>
            Generally, the shipping costs are covered by the lab providing the reagent. However, for long-distance or international exchanges, this can be negotiated between the parties involved. The specific shipping arrangements will be finalized during the swap request process.
          </AccordionContent>
        </AccordionItem>
        
        <AccordionItem value="item-4">
          <AccordionTrigger>Are there restrictions on what reagents can be listed?</AccordionTrigger>
          <AccordionContent>
            Yes, certain restrictions apply for safety and legal reasons. Highly hazardous materials, controlled substances, and reagents with specific transportation regulations may be limited or not allowed on the platform. Each institution should ensure they comply with their local regulations when sharing reagents.
          </AccordionContent>
        </AccordionItem>
        
        <AccordionItem value="item-5">
          <AccordionTrigger>How do I get started with LabSwapp?</AccordionTrigger>
          <AccordionContent>
            Simply sign up with your institutional email, create your profile, and start listing reagents your lab no longer needs. You'll receive initial credits to start requesting reagents from other labs, and you can earn more credits by sharing your own reagents with the community.
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </div>
  );
};

export default FAQSection;
